<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { getCurrentInstance, onMounted } from 'vue';

import DemandForm from '@/components/pass-tourism/DemandForm.vue';
import { i18n } from '@/shared-instance';
import { useGlobalConfigurationStore } from '@/stores/useGlobalConfigurationStore';

i18n.install(getCurrentInstance()!.appContext.app);

const globalConfigurationStore = useGlobalConfigurationStore();
const { globalConfiguration } = storeToRefs(globalConfigurationStore);

onMounted(async () => {
  if (!globalConfiguration.value || !globalConfiguration.value.apikey)
    throw new Error('global configuration for pass-tourism form is missing');
});
</script>

<template>
  <DemandForm v-if="globalConfiguration?.apikey" :api-key="globalConfiguration.apikey" />
</template>
